import managerBidEditTab from './managerBidEditTab';
import bidSetupSteps from './bidSetupSteps';
import rulesSteps from './ruleSetsSteps';
import managerBidDashboard from './managerBidDashboard';
import employeeBidEdit from './employeeBidEdit';

export default {
    [managerBidEditTab.name]: managerBidEditTab.reducer,
    [bidSetupSteps.name]: bidSetupSteps.reducer,
    [rulesSteps.name]: rulesSteps.reducer,
    [managerBidDashboard.name]: managerBidDashboard.reducer,
    [employeeBidEdit.name]: employeeBidEdit.reducer,
};
